export default __webpack_public_path__ + "static/media/clear-night.d9d9422e.mp4";